'use client'
import { MotionConfig } from 'framer-motion'
import EMPSA from './homepage/_components/EMPSA'
import ForBanks from './homepage/_components/ForBanks'
import Hero from './homepage/_components/Hero'
import Product from './homepage/_components/Product'
import Statistics from './homepage/_components/Statistics'
import WhatWeDo from './homepage/_components/WhatWeDo'

export default function HomePage() {

  return (
    <MotionConfig reducedMotion="user">
      <main className="flex flex-col">
        <Hero />
        <Statistics />
        <WhatWeDo />
        <Product />
        <ForBanks />
        <EMPSA />
      </main>
    </MotionConfig>
  )
}
